module.exports = __webpack_public_path__ + "img/reimbursementManagement.78899742.svg";